<template>
  <BaseModal
    small
    :heading="$t('products.schedule_prices')"
    @close="emit('close')"
  >
    <Flex direction="column">
      <BaseText bold>
        {{ $t('products.schedule_changes_heading') }}
      </BaseText>
      <BaseDateTime
        v-model="dateTime"
        :label="$t('global.date_time')"
        :minValue="currentDateTime"
        v-test="'schedule-date'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="emit('close')"
        v-test="'btn-schedule-cancel'"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        @click="emit('submit', dateTime)"
        v-test="'btn-schedule-confirm'"
      >
        {{ $t('products.schedule_prices') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
import dayjs from 'dayjs';
import { ref } from 'vue';
import BaseDateTime from '@/components/BaseDateTime.vue';
import { useServicesPriceScheduleStore } from '@/stores/services-price-schedule';

const emit = defineEmits(['close', 'submit']);

const { scheduledPriceUpdate } = useServicesPriceScheduleStore();

const currentDateTime = dayjs().format();
const initialDateTime = dayjs(
  scheduledPriceUpdate?.scheduledAt || currentDateTime,
).format();
const dateTime = ref(dayjs(initialDateTime).add(1, 'hour').format());
</script>
